import axios from "axios";

export default async function getStatistics(p_baseUrl, p_statisticsRequest) {
    try {
        const response = await axios.post(p_baseUrl + '/admin/getMultipleStatistics', p_statisticsRequest);
        if (response.status === 200) {
            return response.data;
        }
        return 'error';
    } catch (error) {
        console.log("Error getting statistics data from server ", error);
        return 'error';
    }
}
